export const LOOKS_SECTION_ID = "LooksSection";

export const SEE_SIMILAR_OPEN_MODAL_EVENT = "SEE_SIMILAR_OPEN_MODAL_EVENT";
export const LOOKS_OPEN_MODAL_EVENT = "LOOKS_OPEN_MODAL_EVENT";
